import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalBienvenidaComponent } from '../modal-bienvenida/modal-bienvenida.component';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-home-principal',
  templateUrl: './home-principal.component.html',
  styleUrls: ['./home-principal.component.css']
})
export class HomePrincipalComponent implements OnInit {

  nombreUsuario: string | null = this.localStorageService.getItem(Constanst.STORAGE_DATA_USERNAME);
  ultimaConexion: string = 'miércoles 27 de junio de 2022';

  constructor(
    public dialogLogin: MatDialog,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    let firstAdmission = this.localStorageService.getItem(Constanst.STORAGE_DATA_FIRSTADMISSION);
    if (firstAdmission === 'true') {
      const dialog = this.dialogLogin.open(ModalBienvenidaComponent, {
        width: '56rem',
        disableClose: true,
      });
    }
  }
}
